import { BindableFormCheck } from "../components/BindableFormCheck";
import { SimpleFormField } from "../components/SimpleFormField";
import { Trash, ArrowDown, ArrowUp } from "react-bootstrap-icons";
import { Button, FormCheck } from "react-bootstrap";
import { arrayElementMove, useForceRender, getRandomId } from "../util/utils";
import { ObjectSelector } from "../components/ObjectSelector";

export function QuestionEditorFormStates(props) {
	const state = props.state;
	const setState = props.setState;
	const qattr = props.questionsAttribute;
	// Whether we will be using some questions for sections
	const sectionable = props.sectionable;

	let addQuestionAction = () => {
		let qid = getRandomId();
		setState({
			...state,
			[qattr]: [
				...state[qattr],
				{
					"id": getRandomId(),
					"questionId": qid,
					"question": {
						"id": qid,
						"newSection": false,
						"name": "",
						"question": "",
						"resolvable": false,
						"skippable": false,
						"commentsOnly": false
					},
				}
			]
		});
	}

	let removeQuestionAction = (oq) => () => {
		setState({
			...state,
			[qattr]: state[qattr].filter(myoq => (oq != myoq))
		});
	};

	let questionMoveAction = (oq, offset) => () => {
		setState({
			...state,
			[qattr]: arrayElementMove(state[qattr], oq, offset)
		});
	};

	// Our component types aren't in an easy-to-get format so we'll need to do a little work to get them
	const componentTypeDropDown = function(q) {
		const componentTypeObjList = state["surveyComponentTypes"].map( sct => { return sct?.componentType } );
		return <ObjectSelector className={q.newSection ? "": "hidden"} onValueChange={(newVal) => { setComponentTypeValue(newVal, q, "componentTypeId") }} disabled={!q.newSection} options={componentTypeObjList} labelAttribute={"name"} valueAttribute={"id"} defaultValue={q.componentTypeId}/>
	}

	const setComponentTypeValue = function (val, q,  attr ) {
		const newState = {
			...state,
			[qattr]:
				state[qattr].map(qEntry => { if (q !== qEntry.question) {return qEntry;} else return {...qEntry, ["question"]: {...qEntry["question"], [attr]: val}    }; })
			
		};
		setState(newState)
	}
	
	return <div>
		<div className="table-responsive"><table className="table">
			<thead>
				<tr>
					<th>Short Name</th>
					<th>Question or Section Name</th>
					<th>Comments Only?</th>
					<th>Resolvable?</th>
					<th>Skippable?</th>
					{sectionable && <th>New Section?</th>}
					{sectionable && <th>Section Component Type</th>}
					<th></th>
				</tr>
			</thead>
			<tbody>
				{state[qattr].map(oq => {
					let q = oq.question;
					return <tr key={oq.id}>
						<td><SimpleFormField className={q.newSection ? "hidden": ""} bindObject={q} disabled={oq.question.newSection} bindAttribute="name" /></td>
						<td><SimpleFormField bindObject={q} bindAttribute="question" /></td>
						{sectionable && <td><FormCheck checked={q.commentsOnly} className={q.newSection ? "hidden": "check-box"} title="Comment Only" disabled={q.newSection} onClick={(e) => {setComponentTypeValue(e.target.checked, q, "commentsOnly") }} /></td>}
						{sectionable && <td><FormCheck checked={q.resolvable} className={q.newSection ? "hidden": "check-box"} title="Resolvable" disabled={q.newSection} onClick={(e) => {setComponentTypeValue(e.target.checked, q, "resolvable") }} /></td>}
						{sectionable && <td><FormCheck checked={q.skippable} className={q.newSection ? "hidden": "check-box"} title="Skippable" disabled={q.newSection} onClick={(e) => {setComponentTypeValue(e.target.checked, q, "skippable") }} /></td>}
						{sectionable && <td><FormCheck checked={q.newSection} title="New Section" onClick={(e) => {setComponentTypeValue(e.target.checked, q, "newSection") }} /></td>}
						{sectionable && <td>{componentTypeDropDown(q)}</td>}
						<td>
							<ArrowDown className="mx-2 position-arrow" onClick={questionMoveAction(oq, 1)} />
							<ArrowUp className="mx-2 position-arrow" onClick={questionMoveAction(oq, -1)} />
							<Trash className="mx-4 trash" onClick={removeQuestionAction(oq)} />
						</td>
					</tr>;
				})}
			</tbody>
		</table></div>
		{state[qattr].length == 0 && <p>{props.emptyText}</p>}

		<Button onClick={addQuestionAction} className="mb-4">Add Question</Button>
	</div>;
}